import React from 'react';
import classnames from 'classnames';
import { node } from 'prop-types';

import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';
import Tooltip from 'elements/Tooltip/Tooltip';
import { ListElement } from 'elements/Tooltip/Layout';
import Icon from 'foundations/Icons/Icon';
import { ShowCaseConsumer } from '../ShowCase';

import styles from './Label.css';

const Label = ({ children }) => {
  return (
    <ShowCaseConsumer>
      {({ codeSample }) => (
        <div className={classnames('flex flex-justify-between flex-align-center', styles.labelWrapper)}>
          <p className="black small">
            {children}
          </p>
          <div className={styles.copyToClipboard}>
            <CopyToClipboard
              dataText={codeSample}
              render={ copied =>
                <Tooltip
                  target={
                    <Icon
                      icon={copied ? 'confirmation' : 'duplicate'}
                      type={'20'} />
                  }
                  open={copied}
                  placement={'top'}
                >
                  <ListElement>Code Sample Copied!</ListElement>
                </Tooltip>
              }
            />
          </div>
        </div>
      )}
    </ShowCaseConsumer>
  );
};

Label.propTypes = {
  children: node
};

Label.displayName = 'ShowcaseLabel';

export default Label;



// WEBPACK FOOTER //
// ./src/components/ShowCase/Label/Label.js